<script setup>
import { onMounted, computed, inject } from 'vue'
import recognitionItem from './recognition-item.vue'
import { useRoute } from 'vue-router'
import { setTrack } from '@/api/login.js'
import { CheckCircleFilled } from '@ant-design/icons-vue'
import { resolveApiAssetUrl } from '@/utils/algorithmPublicAssets'

const route = useRoute()

const detailData = inject('detailData', null)
const bannerUrl = computed(() =>
  detailData.value?.introduce?.banner_url
    ? resolveApiAssetUrl(detailData.value.introduce.banner_url)
    : '',
)
const routeSource = route.path.slice(11)
const recognitionConfig = computed(() => recognition[routeName] || {})
const experienceList = computed(() => recognitionConfig.value.experience || [])

onMounted(async () => {
  await setTrack({
    position: `algorithm_market > ${routeSource}`,
  })
})
</script>

<template>

  <div class="card">
    <div class="card-bg-black" />
    <div class="card-bg">
      <img v-if="bannerUrl" :src="bannerUrl" loading="eager" />
      <div class="card-msg">
        <div>
          <div class="title">{{ detailData?.name }}</div>
          <div class="dec">
            {{ detailData?.description }}
          </div>
          <!-- <div class="operator">
            <span class="consult" @click="handleConsult">功能咨询</span>
          </div> -->
          <div class="apply">
            <span
              v-for="item in detailData?.introduce?.experience || []"
              :key="item"
              class="apply-btn"
              ><CheckCircleFilled
                style="color: #ed000c; margin-right: 14px"
              />{{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Breadcrumb />
  <Suspense>
    <recognitionItem />
  </Suspense>
</template>

<style lang="scss" scoped>
.mr16 {
  margin-right: 16px;
}
.white {
  color: #fff;
}
.l-15 {
  margin-left: -15px;
}

.card {
  position: relative;
  color: #fff;
  min-width: 1270px;
  width: 100%;

  &-bg {
    height: 463px;
    width: 100%;
    background-color: rgba(6, 37, 83, 0.8);
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      object-fit: cover;
    }
  }

  &-bg-black {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
  }

  &-msg {
    position: absolute;
    left: 240px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title {
    font-size: 55px;
  }

  .dec {
    font-style: normal;
    margin-top: 16px;
    font-size: 18px;
    color: #fff;
    font-weight: 400;
  }

  .operator {
    margin-top: 40px;
    .consult {
      padding: 9px 15px;
      display: inline-block;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ffffff;
      cursor: pointer;
    }
  }
}

:deep() {
  .footer {
    min-width: 1270px;
  }
}
</style>
